export default {
  titles: {
    location: 'Location',
    date_time: 'Date & Time',
  },
};
